import { Navigate, useParams } from "react-router-dom";

import { getDossier } from "../../api/dossier/getDossier";
import { PageDirectoryEntryName } from "../../api/PageDirectory";
import PageContainer from "../../components/PageContainer";
import { isDossierActivated } from "../../helpers/dossiers";
import { useAuth } from "../../providers/AuthProvider";

const RedirectToDossierFromStatus = () => {
  const { dossierId } = useParams();

  const { getScopedPageUrl } = useAuth();

  if (!dossierId) {
    // TODO: improve client side error messaging
    throw new Error("dossier id param is missing");
  }

  const dossier = getDossier(dossierId);

  if (dossier.isError) {
    throw dossier.error;
  }

  const isActivated = dossier.data && isDossierActivated(dossier.data);
  const destination: PageDirectoryEntryName = isActivated
    ? "dossierActivated"
    : "viewDossier";

  return (
    <PageContainer loading={dossier.isLoading}>
      {dossier.isSuccess && (
        <Navigate to={getScopedPageUrl(destination, dossierId)} />
      )}
    </PageContainer>
  );
};

export default RedirectToDossierFromStatus;
